<!--增加安装订单-->
<template>
    <div>
        <div>
            <van-sticky>
                <div style="padding: 10px 0px 0px 0px">
                    <van-icon name="arrow-left" size="20px" @click="onback"/>
                </div>
            </van-sticky>
        </div>
        <div style="padding: 10px;">
            <Row>
                <label>添加安装订单</label>
            </Row>
        </div>

        <div>
            <van-tabs v-model="active">
                <van-tab title="车辆信息">
                    <div>
                        <van-field v-model="installOrder.tempVehicleInfo.registrationNum" label="车牌号"
                                   placeholder="请输入车牌号"/>
                        <van-field v-model="registrationColor"
                                   @click="onregistrationColorOptions" label="车牌颜色" placeholder="请选择车牌颜色" readonly/>
                        <van-popup v-model="showregistrationColorOptions" position="bottom">
                            <van-picker
                                    title="车牌颜色"
                                    show-toolbar
                                    :columns="registrationColorOptions"
                                    @confirm="onConfirmregistrationColorOptions"
                                    @cancel="onCancelregistrationColorOptions"
                            />
                        </van-popup>
                        <van-field v-model="installOrder.tempVehicleInfo.vin" label="车架号" placeholder="请输入车架号"/>
                        <van-field v-model="installOrder.tempVehicleInfo.engineNum" label="发动机号" placeholder="请输入发动机号"/>
                        <van-field v-model="businessUserId"
                                   @click="onbusinessUserId" label="业务员" placeholder="业务员" readonly/>
                        <van-popup v-model="showbusinessUserId" position="bottom">
                            <van-picker
                                    title="业务员"
                                    show-toolbar
                                    :columns="businessUserIdOptions"
                                    @confirm="onConfirmbusinessUserId"
                                    @cancel="onCancelbusinessUserId"
                            />
                        </van-popup>
                        <Card>
                            <van-checkbox v-model="installOrder.tempVehicleInfo.attention">重点关注</van-checkbox>
                        </Card>
                        <Card>
                            <van-checkbox v-model="installOrder.reInstall">重新安装</van-checkbox>
                        </Card>
                        <Card>
                            <van-checkbox v-model="installOrder.receptDatetime">是否已收款</van-checkbox>
                        </Card>
                        <Card>
                            <van-checkbox v-model="installOrder.urgent">是否加急</van-checkbox>
                        </Card>
                    </div>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="客户信息">
                    <div style="padding: 5px;">
                        <Form>

                            <FormItem>
                                <Select
                                        placeholder="请选择客户名称"
                                        v-model="installOrder.clientInfoId"
                                        filterable
                                        remote
                                        :remote-method="searchClientInfo"
                                        :loading="searchClientInfoLoading"
                                        class="field" style="width: 65%;"
                                        clearable>
                                    <Option v-for="(option, index) in searchClientInfoList" :value="option.id"
                                            :key="option.id">{{option.name}}
                                    </Option>
                                </Select>
                                <Button type="primary" style="margin-left: 5px;width: 100px;"
                                        @click="onAddClientInfoBtn">添加客户信息
                                </Button>
                            </FormItem>
                            <add-client-info-modal v-model="addClientInfoModal" :businessUserId="installOrder.businessUserId" @on-success="onSuccess"></add-client-info-modal>
                            <FormItem>
                                <Select
                                        placeholder="请选择车辆所有人名称"
                                        v-model="installOrder.tempVehicleInfo.vehicleOwnerInfoId"
                                        filterable
                                        remote
                                        :remote-method="searchVehicleOwnerInfo"
                                        :loading="searchVehicleOwnerInfoLoading"
                                        class="field" style="width: 65%;"
                                        clearable>
                                    <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id"
                                            :key="option.id">{{option.name}}
                                    </Option>
                                </Select>
                                <Button type="primary" style="margin-left: 5px;width: 100px;"
                                        @click="onAddVehicleOwnerInfoBtn">添加所有人
                                </Button>
                            </FormItem>
                            <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
                            <FormItem>
                                <Select
                                        placeholder="请选择车辆分组名称"
                                        v-model="installOrder.vehicleInfoGroupId"
                                        filterable
                                        remote
                                        :remote-method="searchVehicleInfoGroup"
                                        :loading="searchVehicleInfoGroupLoading"
                                        class="field" style="width: 65%;"
                                        clearable>
                                    <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id"
                                            :key="option.id">{{option.name}}
                                    </Option>
                                </Select>
<!--                                <Button type="primary" style="margin-left: 5px;width: 100px;"-->
<!--                                        @click="onAddClientInfoGroupBtn">添加车辆分组-->
<!--                                </Button>-->
                            </FormItem>

                            <FormItem>
                                <Select placeholder="请选择销售渠道"
                                        v-model="installOrder.salesChannelId"
                                        filterable
                                        remote
                                        :remote-method="searchSalesChannel"
                                        :loading="searchSalesChannelLoading"
                                        class="field" style="width: 65%;"
                                        clearable>
                                    <Option v-for="(option, index) in searchSalesChannelList" :value="option.id"
                                            :key="option.id">{{option.name}}
                                    </Option>
                                </Select>
                                <Button type="primary" style="margin-left: 5px;width: 100px;"
                                        @click="onAddsearchSalesBtn">添加销售渠道
                                </Button>
                            </FormItem>
                            <add-saleschannel-info-modal v-model="addSaleschannelInfoModal" @on-success="onSuccess"></add-saleschannel-info-modal>
                        </Form>
                    </div>
                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="订单信息">
                    <div>
                        <van-field v-model="serviceDatetime"
                                   @click="onserviceDatetime" label="有效服务期" placeholder="有效服务期" readonly/>
                        <van-popup v-model="showserviceDatetime" position="bottom">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="date"
                                    title="有效服务期"
                                    :min-date="minDate"
                                    @confirm="onConfirmserviceDatetime"
                                    @cancel="onCancelserviceDatetime"
                            />
                        </van-popup>
                        <!--                        <van-field v-model="installOrder.totalAmount" label="应收总金额"-->
                        <!--                                   placeholder="请输入金额"/>-->
                        <van-field
                                label="应收总金额"
                                readonly
                                clickable
                                :value="installOrder.totalAmount"
                                @touchstart.native.stop="showtotalAmount = true"
                        />
                        <van-number-keyboard
                                v-model="installOrder.totalAmount"
                                :show="showtotalAmount"
                                :maxlength="6"
                                @blur="showtotalAmount = false"
                                close-button-text="完成"
                                theme="custom"
                                extra-key="."
                                @input="onInput"
                                @delete="onDelete"
                        />
                        <van-field v-model="businessType"
                                   @click="onbusinessType" label="业务类型" placeholder="请选择业务类型" readonly/>
                        <van-popup v-model="showbusinessType" position="bottom">
                            <van-picker
                                    title="业务类型"
                                    show-toolbar
                                    :columns="businessTypeOptions"
                                    @confirm="onConfirmbusinessType"
                                    @cancel="onCancelbusinessType"
                            />
                        </van-popup>
                        <van-field v-model="billType"
                                   @click="onbillType" label="开票类型" placeholder="请选择业务类型" readonly/>
                        <van-popup v-model="showbillType" position="bottom">
                            <van-picker
                                    title="开票类型"
                                    show-toolbar
                                    :columns="billTypeOptions"
                                    @confirm="onConfirmbillType"
                                    @cancel="onCancelbillType"
                            />
                        </van-popup>
                        <van-field v-model="qghyptOption"
                                   @click="onqghyptOption" label="货运平台" placeholder="请选择货运平台" readonly/>
                        <van-popup v-model="showqghyptOption" position="bottom">
                            <van-picker
                                    title="货运平台"
                                    show-toolbar
                                    :columns="qghyptOptionOptions"
                                    @confirm="onConfirmqghyptOption"
                                    @cancel="onCancelqghyptOption"
                            />
                        </van-popup>

                        <van-field v-model="bookingDatetime"
                                   @click="onbookingDatetime" label="预约安装时间" placeholder="预约安装时间" readonly/>
                        <van-popup v-model="showbookingDatetime" position="bottom">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="date"
                                    title="预约安装时间"
                                    :min-date="minDate"
                                    @confirm="onConfirmbookingDatetime"
                                    @cancel="onCancelbookingDatetime"
                            />
                        </van-popup>
                        <van-field v-model="installOrder.bookingPlace" label="预约安装地点" placeholder="预约安装地点"/>

                        <van-field v-model="isfree"
                                   @click="onisfree" label="订单类型" placeholder="请选择订单类型" readonly/>
                        <van-popup v-model="showisfree" position="bottom">
                            <van-picker
                                    title="订单类型"
                                    show-toolbar
                                    :columns="isfreeOptions"
                                    @confirm="onConfirmisfree"
                                    @cancel="onCancelisfree"
                            />
                        </van-popup>
                        <div v-if="isfree != '自费安装模式' ?true: false">
                        <van-field v-model="mliftainsuranceChannelId"
                                   @click="onmliftainsuranceChannelId" label="交强险公司" placeholder="请选择交强险公司" readonly/>
                        <van-popup v-model="showmliftainsuranceChannelId" position="bottom">
                            <van-picker
                                    title="交强险公司"
                                    show-toolbar
                                    :columns="mliftainsuranceChannelIdOptions"
                                    @confirm="onConfirmmliftainsuranceChannelId"
                                    @cancel="onCancelmliftainsuranceChannelId"
                            />
                        </van-popup>
                        <van-field v-model="mliftainsurancechannelDatetime"
                                   @click="onmliftainsurancechannelDatetime" label="交强险有效期" placeholder="交强险有效期" readonly/>
                        <van-popup v-model="showmliftainsurancechannelDatetime" position="bottom">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="date"
                                    title="交强险有效期"
                                    :min-date="minDate"
                                    @confirm="onConfirmmliftainsurancechannelDatetime"
                                    @cancel="onCancelmliftainsurancechannelDatetime"
                            />
                        </van-popup>
                        <van-field v-model="tiinsuranceChannelId"
                                   @click="ontiinsuranceChannelId" label="商业险公司" placeholder="请选择商业险公司" readonly/>
                        <van-popup v-model="showtiinsuranceChannelId" position="bottom">
                            <van-picker
                                    title="商业险公司"
                                    show-toolbar
                                    :columns="tiinsuranceChannelIdOptions"
                                    @confirm="onConfirmtiinsuranceChannelId"
                                    @cancel="onCanceltiinsuranceChannelId"
                            />
                        </van-popup>
                        <van-field v-model="tiinsurancechannelDatetime"
                                   @click="ontiinsurancechannelDatetime" label="商业险有效期" placeholder="商业险有效期" readonly/>
                        <van-popup v-model="showtiinsurancechannelDatetime" position="bottom">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="date"
                                    title="商业险有效期"
                                    :min-date="minDate"
                                    @confirm="onConfirmtiinsurancechannelDatetime"
                                    @cancel="onCanceltiinsurancechannelDatetime"
                            />
                        </van-popup>
                        </div>
                    </div>
                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="其他">

                        <van-field
                                v-model="installOrder.remark"
                                rows="2"
                                autosize
                                label="备注"
                                type="textarea"
                                placeholder="请输入备注"
                        />

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="配机">
                    <div v-if="installOrder.positioningDeviceInfosCount == 0">
                        <Card style="width:100%">
                            <Row>
                                <label>未绑定设备</label>
                            </Row>
                        </Card>
                    </div>
                    <div v-for="index in installOrder.positioningDeviceInfos">
                        <Card style="width:100%">
                            <Row>
                                <label>主机号：{{index.terminalNum}}</label>
                            </Row>
                            <Row>
                                <label>设备型号：{{index.positioningDeviceModel.name}}</label>
                                <!--                            </Row>-->
                                <!--                            <Row>-->
                                <Button style="position:absolute;right: 10px;" type="error" size="small"
                                        @click="onunBindPositioningDeviceInfos(index.id)">解绑
                                </Button>
                            </Row>
                        </Card>
                    </div>

                    <div style="position: fixed;bottom: 50px;width: 100%;padding: 5px;">
                        <Form autoComplete="on" class="card-box login-form">
                            <Row>
                                <Form-item label="设备主机号">
                                    <Select style="width: 48%;padding-right: 5px;"
                                            v-model="selectPositioningDeviceInfos"
                                            multiple
                                            filterable
                                            remote
                                            :remote-method="searchPositioningDeviceInfo"
                                            :loading="searchPositioningDeviceInfoLoading">
                                        <Option v-for="(option, index) in searchPositioningDeviceInfoList"
                                                :value="option.id" :key="option.id">{{option.terminalNum}}
                                        </Option>
                                    </Select>
                                    <Button type="primary" @click="onBindPositioningDeviceInfos" style="margin-right: 5px;">绑定</Button>
                                    <Button type="primary" @click="addPositioningDeviceInfoModal = true">添加</Button>
                                </Form-item>
                            </Row>
                        </Form>
                    </div>
                    <add-positioning-device-info-modal v-model="addPositioningDeviceInfoModal"></add-positioning-device-info-modal>
                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="配件">

                    <div v-if="positioningDeviceFittingsInfos.length == 0">
                        <Card style="width:100%">
                            <Row>
                                <label>未绑定设备配件
                                </label>
                                <Button type="primary" size="small" @click="onaddPositioningDeviceFittingsInfos" style="float: right;">添加</Button>
                            </Row>
                        </Card>
                    </div>

                    <div v-for="index in positioningDeviceFittingsInfos">
                        <Card style="width:100%">
                            <Row>
                                <label>设备型号：{{index.positioningDeviceModel.name}}</label>
                            </Row>
                            <!--                            <Row>-->
                            <!--                                <Button style="position:absolute;right: 20px;bottom: 00px;" type="error" size="small"-->
                            <!--                                        @click="onunBindPositioningDeviceInfos(index.id)">解绑-->
                            <!--                                </Button>-->
                            <!--                            </Row>-->
                            <van-collapse v-model="activeNames">
                                <van-collapse-item name="1">
                                    <Row>
                                        <Form ref="loginForm" :model="positioningDeviceFittingsInfos">
                                            <!--                                <FormItem prop="positioningdevicemodel">-->
                                            <!--                                    <label>定位设备类型：</label>-->
                                            <!--                                    <Select placeholder="请选择设备类型" style="display: inline-block; width: 130px;" @on-change="selectPositioningDeviceInfo" :disabled="!modify"-->
                                            <!--                                            v-model="index.positioningDeviceModelId"  size="small"-->
                                            <!--                                    >-->
                                            <!--                                        <Option v-for="(option, index) in positioningDeviceType" :value="option.id" :key="option.id">{{option.name}}</Option>-->
                                            <!--                                    </Select>-->
                                            <!--                                    <Checkbox v-model="index.lcdproperties" :disabled="!modify" style="padding-left: 5px">LCD属性</Checkbox>-->
                                            <!--                                </FormItem>-->
                                            <FormItem prop="starLightAlarm">
                                                <Checkbox v-model="index.starLightAlarm" :disabled="!modify">声光报警：
                                                </Checkbox>
                                                <Select placeholder="请选择声光报警类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.starLightAlarm || !modify"
                                                        v-model="index.starLightAlarmid" size="small"
                                                >
                                                    <Option v-for="(option, index) in starLightAlarmType"
                                                            :value="option.id" :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="interphone">
                                                <Checkbox v-model="index.interphone" :disabled="!modify">对讲机：</Checkbox>
                                                <Select placeholder="请选择对讲机类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.interphone || !modify"
                                                        v-model="index.interphoneid" size="small"
                                                >
                                                    <Option v-for="(option, index) in interphoneType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="trumpet">
                                                <Checkbox v-model="index.trumpet" :disabled="!modify">喇叭：</Checkbox>
                                                <Select placeholder="请选择喇叭类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.trumpet || !modify"
                                                        v-model="index.trumpetid" size="small"
                                                >
                                                    <Option v-for="(option, index) in trumpetType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="trumpet">
                                                <Checkbox v-model="index.viewingScreen" :disabled="!modify">显示屏：
                                                </Checkbox>
                                                <Select placeholder="请选择显示屏类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.viewingScreen || !modify"
                                                        v-model="index.viewingScreenid" size="small"
                                                >
                                                    <Option v-for="(option, index) in viewingScreenType"
                                                            :value="option.id" :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="hardDisk">
                                                <Checkbox v-model="index.hardDisk" :disabled="!modify">硬盘：</Checkbox>
                                                <Select placeholder="请选择硬盘类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.hardDisk || !modify"
                                                        v-model="index.hardDiskid" size="small"
                                                >
                                                    <Option v-for="(option, index) in hardDiskType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="extensionCord">
                                                <Checkbox v-model="index.extensionCord" :disabled="!modify">延长线：
                                                </Checkbox>
                                                <div style="display: inline-table;">
                                                    <Select placeholder="1米延长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordOneid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordOneNum" :min="0"
                                                                 :disabled="!index.extensionCord  || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="5米长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordFiveid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordFiveNum" :min="0"
                                                                 :disabled="!index.extensionCord || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="15米延长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordFifteenid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordFifteenNum" :min="0"
                                                                 :disabled="!index.extensionCord || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                </div>
                                            </FormItem>
                                            <!--          </div>-->
                                            <!--          <div slot="right" class="demo-split-pane">-->
                                            <FormItem prop="trumpet">
                                                <InputNumber v-model="index.cameraMatchADAS" :min="0"
                                                             :disabled="!modify" size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                                <InputNumber v-model="index.cameraMatch" :min="0" :disabled="!modify"
                                                             size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                                <InputNumber v-model="index.cameraMatchNetwork" :min="0"
                                                             :disabled="!modify" size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                            </FormItem>
                                            <FormItem prop="Match">
                                                <Checkbox v-model="index.camera" :disabled="!modify">摄像头：</Checkbox>
                                                <div style="display: inline-table;">
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraOneid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraOneNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraTwoid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraTwoNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraThreeid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraThreeNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraFourid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraFourNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraFiveid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraFiveNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                </div>
                                            </FormItem>
                                        </Form>
                                    </Row>
                                </van-collapse-item>
                            </van-collapse>

                        </Card>
                    </div>



                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="派单">
                    <van-field v-model="installOrder.installer"
                               @click="oninstallerId" label="安装员" placeholder="安装员" readonly/>
                    <van-popup v-model="showinstallerId" position="bottom">
                        <van-picker
                                title="安装员"
                                show-toolbar
                                :columns="installerIdOptions"
                                @confirm="onConfirminstallerId"
                                @cancel="onCancelinstallerId"
                        />
                    </van-popup>




                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onSueeess(active)">
                        确认
                    </Button>
                </van-tab>
            </van-tabs>
        </div>
        <add-positioning-devicer-fittings-modal  v-model="AddPositioningDeviceFittingsModal" :initValue="AddPositioningDeviceFittingsModalId"
                                                :terminalNumValue="AddPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="onPositioningdevicefittings"></add-positioning-devicer-fittings-modal>

    </div>
</template>
<script>
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'
    import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

    import AddPositioningDeviceInfoModal from '@/views/im/components/add-positioning-device-info-modal'
    import AddClientInfoModal from '@/views/crm/components/add-client-info-modal'
    import AddVehicleOwnerInfoModal from '@/views/crm/components/add-vehicle-owner-info-modal'
    import AddSaleschannelInfoModal from '@/views/crm/components/add-saleschannel-info-modal'
    import AddPositioningDevicerFittingsModal from '@/views/om/components/add-positioning-devicer-fittings-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,
        Overlay,
        NumberKeyboard,
        Tab, Tabs
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Tab).use(Tabs)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay).use(NumberKeyboard)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

    export default {
        inject: ['reload'],
        name: "AddInstallOrder",
        components: {
            AddPositioningDeviceInfoModal,
            AddClientInfoModal,
            AddVehicleOwnerInfoModal,
            AddSaleschannelInfoModal,
            AddPositioningDevicerFittingsModal,
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data() {
            return {
                active: null,//流程页下标

                //返回路径
                onbackid:null,

                //订单信息
                installOrder: {
                    totalAmount: '',
                    serviceDatetime: null,
                    businessUserId: null,
                    businessType: 1,
                    multiDevices: false,
                    qghyptOption: 0,
                    clientInfoId: null,
                    remark: null,
                    billType: 1,
                    vehicleInfoGroupId: null,
                    vehicleInfoGroupId: null,
                    positioningDeviceId: null,
                    vehicleInfoId: null,
                    isfree: 1,
                    reInstall: false,
                    tempVehicleInfo: {
                        customName: null,
                        registrationNum: null,
                        registrationColor: null,
                        vin: null,
                        bodyColor: null,
                        vehicleType: {
                            name: null
                        },
                        vehicleBrand: {
                            name: null
                        },
                        engineNum: null,
                        vehicleLicenseNum: null,
                        unladenMass: null,
                        approvedLoad: null,
                        vehicleOwnerInfoId: null,
                        servicePassword: null,
                        vehicleLicenseDistributeDatetime: null,
                        vehicleLicenseReigsterDatetime: null,
                        remark: null,
                        certificateNum: null,
                        certificateDistributeDatetime: null,
                        vehicleModel: {
                            name: null
                        },
                        chassisModel: null,
                        chassisId: null,
                        chassisCertificateNum: null,
                        engineModel: null,
                        energyType: null,
                        displacement: null,
                        power: null,
                        energyUsage: null,
                        emissionStandard: null,
                        manufacturer: null,
                        outlineSizeLong: null,
                        outlineSizeWidth: null,
                        outlineSizeHeight: null,
                        boxSizeLong: null,
                        boxSizeWidth: null,
                        boxSizeHeight: null,
                        springPieceCount: null,
                        tyreCount: null,
                        tyreSpec: null,
                        wheelSpanFront: null,
                        wheelSpanBack: null,
                        wheelBase: null,
                        axisLoad: null,
                        axisCount: null,
                        turnType: null,
                        totalMass: null,
                        approvedLoadCoefficient: null,
                        towMax: null,
                        saddleMax: null,
                        cabPeopleCount: null,
                        mannedCount: null,
                        speedMax: null,
                        productionDatetime: null,
                        certificateRemark: null,
                        vehicleLicensePictureId: null,
                        certificatePictureId: null,
                        vehicleSrcLicensePicture1Id: null,
                        vehicleSrcLicensePicture2Id: null,
                        vehicleBodyPictureId: null,
                        vehicleUse: null,
                        attention: false,
                        mliftainsuranceChannelId: null,
                        mliftainsurancechannelDatetime: null,
                        tiinsuranceChannelId: null,
                        tiinsurancechannelDatetime: null,
                        insured: null,
                    },
                    salesChannelId: null,
                    urgent:false,
                    receptDatetime:false,
                    stepId:null,
                    step:{
                        orderId:null,
                        state:null,
                        lastState:null,
                        userId:null,
                        user:null,
                        result:null,
                    },
                    bookingDatetime:new Date(new Date().setDate(new Date().getDate()+1)),
                    bookingPlace:null,
                    actualDatetime:null,
                    actualPlace:null,
                },
                /**
                 * 选择车牌颜色
                 */
                registrationColor:'',
                showregistrationColorOptions: false,
                registrationColorOptions: [
                    '蓝色',
                    '黄色',
                    '黑色',
                    '白色',
                    '绿色',
                ],

                /**
                 * 选择客户信息
                 */
                searchClientInfoLoading: false,
                searchClientInfoList: [],

                // 添加客户信息
                addClientInfoModal: false,

                /**
                 * 选择车辆所有人
                 */
                searchVehicleOwnerInfoLoading: false,
                searchVehicleOwnerInfoList: [],

                // 添加车辆所有人
                addVehicleOwnerInfoModal: false,

                /**
                 * 选择车辆分组
                 */
                searchVehicleInfoGroupList: [],
                searchVehicleInfoGroupLoading: false,
                /**
                 * 选择销售渠道
                 */
                searchSalesChannelLoading: false,
                searchSalesChannelList: [],

                //添加销售渠道
                addSaleschannelInfoModal:false,

                /**
                 * 服务期选择
                 */
                serviceDatetime:'',
                showserviceDatetime: false,
                minDate: new Date(2021, 6, 1),
                currentDate: new Date(),
                /**
                 * 填写金额
                 */
                showtotalAmount: false,

                /**
                 * 选择业务类型
                 */
                businessType: '新装',
                showbusinessType: false,
                businessTypeOptions: [
                    '新装',
                    '接入',
                ],

                /**
                 * 选择开票类型
                 */
                billType: '增值税发票',
                showbillType: false,
                billTypeOptions: [
                    '增值税发票',
                    '增值税专用发票',
                    '增值税普通发票',
                ],
                /**
                 * 选择全国货运平台
                 */
                qghyptOption: '不需上传',
                showqghyptOption: false,
                qghyptOptionOptions: [
                    '不需上传',
                    '新车上传',
                    '旧车转网',
                ],
                /**
                 *
                 */
                bookingDatetime:'',
                showbookingDatetime: false,
                /**
                 * 选择订单类型
                 */
                isfree:'自费安装模式',
                showisfree: false,
                isfreeOptions: [
                    '自费安装模式',
                    '普通免费模式',
                    '太好保模式',
                ],
                /**
                 * 选择车辆交强险公司
                 */
                mliftainsuranceChannelId:'',
                showmliftainsuranceChannelId: false,
                mliftainsuranceChannelIdOptions: [],
                /**
                 * 选择车辆交强险有效期
                 */
                mliftainsurancechannelDatetime:'',
                showmliftainsurancechannelDatetime: false,
                /**
                 * 选择车辆商业险公司
                 */
                tiinsuranceChannelId:'',
                showtiinsuranceChannelId: false,
                tiinsuranceChannelIdOptions: [],
                /**
                 * 选择车辆商业险有效期
                 */
                tiinsurancechannelDatetime:'',
                showtiinsurancechannelDatetime: false,
                /**
                 * 选择业务员
                 */
                businessUserId:'',
                showbusinessUserId: false,
                businessUserIdOptions: [],

                /**
                 * 配机
                 */
                searchPositioningDeviceInfoList: [],//查询设备
                searchPositioningDeviceInfoLoading: false,
                selectPositioningDeviceInfos: [],//查询设备后选择设备

                /**
                 * 添加设备信息
                 */
                addPositioningDeviceInfoModal:false,

                /**
                 * 选择安装员
                 */
                showinstallerId: false,
                installerIdOptions: [],

                /**
                 * 配置订单配件
                 */
                positioningDeviceFittingsInfos: [],//已绑定的设备配件
                // 添加定位设备配件
                AddPositioningDeviceFittingsModal: false,
                AddPositioningDeviceFittingsModalId: null,
                AddPositioningDeviceFittingsModalterminalNum: null,
                activeNames: [],//配件详情显示
            }
        },
        methods: {
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: this.onbackid
                })
            },
            /**
             * 流程上一步
             */
            onLastPage(page) {
                console.log(page)
                this.active = page - 1;
            },
            /**
             * 流程下一步
             */
            onNextPage(page) {
                console.log(page)
                if (page == 3) {

                    if (this.installOrder.receptDatetime){
                        this.installOrder.receptDatetime = new Date()
                    } else {
                        this.installOrder.receptDatetime = null
                    }

                    this.$Modal.confirm({
                        title: '添加安装订单信息',
                        content: '<p>添加安装订单信息</p>',
                        onOk: () => {
                            store.dispatch('InstallOrderServ_AddObj', { params: this.installOrder }).then(() => {
                                this.$Message.success('添加安装订单')
                                this.installOrder.id = store.getters.get_InstallOrder_AddObjResult.id;
                                this.active = page + 1;
                                this.$emit('on-success')
                            }).catch(err => {
                                this.$Message.error(err)
                                this.$emit('on-fail')
                            })
                        },
                        onCancel: () => {
                        }
                    })

                }else {
                    this.active = page + 1;
                }
            },
            /**
             * 安装确认
             */
            onSueeess() {
                this.$Modal.confirm({
                    title: '指派安装员',
                    content: '<p>是否确认指派安装员</p>',
                    onOk: () => {
                        // console.log(this.installOrder)
                        store.dispatch('InstallOrderServ_ChangeInstaller', {params: this.installOrder}).then(() => {
                            this.$Message.success('指派安装员成功')
                            this.$emit('on-success');
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail');
                        })
                    },
                    onCancel: () => {
                    }
                })
            },
            /**
             * 选择车牌颜色
             */
            onregistrationColorOptions() {
                if (this.showregistrationColorOptions) {
                    this.showregistrationColorOptions = false
                } else {
                    this.showregistrationColorOptions = true
                }
            },
            onConfirmregistrationColorOptions(value, index) {
                console.log(value)
                this.registrationColor = value
                this.installOrder.tempVehicleInfo.registrationColor = index +1
                this.showregistrationColorOptions = false
            },
            onCancelregistrationColorOptions() {
                this.showregistrationColorOptions = false
            },
            /**
             * 选择客户信息
             */
            searchClientInfo(input) {
                this.searchClientInfoLoading = true
                if (!input || input.length <= 0) {
                    this.searchClientInfoList = []
                    this.searchClientInfoLoading = false
                } else {
                    store.dispatch('ClientInfoServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
                        this.searchClientInfoLoading = false
                    }).catch(err => {
                        this.searchClientInfoLoading = false
                    })
                }
            },
            onAddClientInfoBtn(){
                if (!this.installOrder.businessUserId) {
                    this.$Message.error('请先选择跟进业务员')
                    return
                }
                this.addClientInfoModal = true
            },
            /**
             * 选择车辆所有人
             */
            searchVehicleOwnerInfo(input) {
                this.searchVehicleOwnerInfoLoading = true
                if (!input || input.length <= 0) {
                    this.searchVehicleOwnerInfoList = []
                    this.searchVehicleOwnerInfoLoading = false
                } else {
                    store.dispatch('VehicleOwnerInfoServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
                        this.searchVehicleOwnerInfoLoading = false
                    }).catch(err => {
                        this.searchVehicleOwnerInfoLoading = false
                    })
                }
            },
            onAddVehicleOwnerInfoBtn () {
                this.addVehicleOwnerInfoModal = true
            },
            /**
             * 选择车辆分组
             */
            searchVehicleInfoGroup(input) {
                this.searchVehicleInfoGroupLoading = true
                if (!input || input.length <= 0) {
                    this.searchVehicleInfoGroupList = []
                    this.searchVehicleInfoGroupLoading = false
                } else {
                    store.dispatch('VehicleInfoGroupServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
                        this.searchVehicleInfoGroupLoading = false
                    }).catch(err => {
                        this.searchVehicleInfoGroupLoading = false
                    })
                }
            },

            /**
             * 选择销售渠道
             */
            searchSalesChannel(input) {
                this.searchSalesChannelLoading = true
                if (!input || input.length <= 0) {
                    this.searchSalesChannelList = []
                    this.searchSalesChannelLoading = false
                } else {
                    store.dispatch('SalesChannelServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
                        this.searchSalesChannelLoading = false
                    }).catch(err => {
                        this.searchSalesChannelLoading = false
                    })
                }
            },
            onAddsearchSalesBtn () {
                this.addSaleschannelInfoModal = true
            },
            onserviceDatetime() {
                if (this.showserviceDatetime) {
                    this.showserviceDatetime = false
                } else {
                    this.showserviceDatetime = true
                }
            },
            onConfirmserviceDatetime(value) {
                this.serviceDatetime = value.Format('yyyy-MM-dd')
                this.installOrder.serviceDatetime = new Date(value)
                this.showserviceDatetime = false
            },
            onCancelserviceDatetime() {
                this.showserviceDatetime = false
            },
            onbookingDatetime(){
                if (this.showbookingDatetime) {
                    this.showbookingDatetime = false
                } else {
                    this.showbookingDatetime = true
                }
            },
            onConfirmbookingDatetime(value) {
                this.bookingDatetime = value.Format('yyyy-MM-dd')
                this.installOrder.bookingDatetime = new Date(value)
                this.showbookingDatetime = false
            },
            onCancelbookingDatetime() {
                this.showbookingDatetime = false
            },
            onInput(value) {
                // console.log(value)
                // Toast.success(value);
            },
            onDelete() {
            },
            /**
             * 选择业务类型
             */
            onbusinessType() {
                if (this.showbusinessType) {
                    this.showbusinessType = false
                } else {
                    this.showbusinessType = true
                }
            },
            onConfirmbusinessType(value, index) {
                this.businessType = value
                this.installOrder.businessType = index + 1
                this.showbusinessType = false
            },
            onCancelbusinessType() {
                this.showbusinessType = false
            },
            /**
             * 选择开票类型
             */
            onbillType() {
                if (this.showbillType) {
                    this.showbillType = false
                } else {
                    this.showbillType = true
                }
            },
            onConfirmbillType(value, index) {
                this.billType = value
                this.installOrder.billType = index + 1
                this.showbillType = false
            },
            onCancelbillType() {
                this.showbillType = false
            },
            /**
             * 选择全国货运平台
             */
            onqghyptOption() {
                if (this.showqghyptOption) {
                    this.showqghyptOption = false
                } else {
                    this.showqghyptOption = true
                }
            },
            onConfirmqghyptOption(value, index) {
                this.qghyptOption = value
                this.installOrder.qghyptOption = index + 1
                this.showqghyptOption = false
            },
            onCancelqghyptOption() {
                this.showqghyptOption = false
            },
            /**
             * 选择订单类型
             */
            onisfree(){
                if (this.showisfree) {
                    this.showisfree = false
                } else {
                    this.showisfree = true
                }
            },
            onConfirmisfree(value, index) {
                this.isfree = value
                this.installOrder.isfree = index + 1
                this.showisfree = false
            },
            onCancelisfree() {
                this.showisfree = false
            },
            /**
             * 选择车辆交强险公司
             */
            onmliftainsuranceChannelId(){
                if (this.showmliftainsuranceChannelId) {
                    this.showmliftainsuranceChannelId = false
                } else {
                    this.showmliftainsuranceChannelId = true
                }
            },
            onConfirmmliftainsuranceChannelId(value, index) {
                this.mliftainsuranceChannelId = value
                store.dispatch('InsuranceChannelServ_SearchByName', {
                    params: { name: this.mliftainsuranceChannelId },
                    urlparams: null
                }).then(() => {
                    if (store.getters.get_InsuranceChannel_SearchByNameResult) {
                        this.installOrder.tempVehicleInfo.mliftainsuranceChannelId = store.getters.get_InsuranceChannel_SearchByNameResult[0].id
                    }
                }).catch(err => {
                })
                this.showmliftainsuranceChannelId = false
            },
            onCancelmliftainsuranceChannelId() {
                this.showmliftainsuranceChannelId = false
            },
            /**
            * 选择交强险有效期
            */
            onmliftainsurancechannelDatetime() {
                if (this.showmliftainsurancechannelDatetime) {
                    this.showmliftainsurancechannelDatetime = false
                } else {
                    this.showmliftainsurancechannelDatetime = true
                }
            },
            onConfirmmliftainsurancechannelDatetime(value) {
                this.mliftainsurancechannelDatetime = value.Format('yyyy-MM-dd')
                this.installOrder.tempVehicleInfo.mliftainsurancechannelDatetime = new Date(value)
                this.showmliftainsurancechannelDatetime = false
            },
            onCancelmliftainsurancechannelDatetime() {
                this.showmliftainsurancechannelDatetime = false
            },
            /**
             * 选择车辆商业险公司
             */
            ontiinsuranceChannelId(){
                if (this.showtiinsuranceChannelId) {
                    this.showtiinsuranceChannelId = false
                } else {
                    this.showtiinsuranceChannelId = true
                }
            },
            onConfirmtiinsuranceChannelId(value, index) {
                this.tiinsuranceChannelId = value
                store.dispatch('InsuranceChannelServ_SearchByName', {
                    params: { name: this.tiinsuranceChannelId },
                    urlparams: null
                }).then(() => {
                    if (store.getters.get_InsuranceChannel_SearchByNameResult) {
                        this.installOrder.tempVehicleInfo.tiinsuranceChannelId = store.getters.get_InsuranceChannel_SearchByNameResult[0].id
                    }
                }).catch(err => {
                })
                this.showtiinsuranceChannelId = false
            },
            onCanceltiinsuranceChannelId() {
                this.showtiinsuranceChannelId = false
            },
            /**
             * 选择商业险有效期
             */
            ontiinsurancechannelDatetime() {
                if (this.showtiinsurancechannelDatetime) {
                    this.showtiinsurancechannelDatetime = false
                } else {
                    this.showtiinsurancechannelDatetime = true
                }
            },
            onConfirmtiinsurancechannelDatetime(value) {
                this.tiinsurancechannelDatetime = value.Format('yyyy-MM-dd')
                this.installOrder.tempVehicleInfo.tiinsurancechannelDatetime = new Date(value)
                this.showtiinsurancechannelDatetime = false
            },
            onCanceltiinsurancechannelDatetime() {
                this.showtiinsurancechannelDatetime = false
            },
            /**
             * 选择业务员
             */
            onbusinessUserId(){
                if (this.showbusinessUserId) {
                    this.showbusinessUserId = false
                } else {
                    this.showbusinessUserId = true
                }
            },
            onConfirmbusinessUserId(value, index) {
                this.businessUserId = value
                store.dispatch('UserServ_GetPage', {
                    params: null,
                    urlparams: {keyword: this.businessUserId}
                }).then(() => {
                    if (store.getters.get_User_GetPageResult.content) {
                        this.installOrder.businessUserId = store.getters.get_User_GetPageResult.content[0].id
                    }
                }).catch(err => {
                })
                this.showbusinessUserId = false
            },
            onCancelbusinessUserId() {
                this.showbusinessUserId = false
            },

            /**
             * 模糊查询设备
             */
            searchPositioningDeviceInfo(input) {
                console.log(input)
                this.searchPositioningDeviceInfoLoading = true
                if (!input || input.length <= 0) {
                    this.searchPositioningDeviceInfoList = []
                    this.searchPositioningDeviceInfoLoading = false
                } else {
                    store.dispatch('PositioningDeviceInfoServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
                        this.searchPositioningDeviceInfoLoading = false
                    }).catch(err => {
                        this.searchPositioningDeviceInfoLoading = false
                    })
                }
            },
            /**
             * 绑定订单设备
             */
            onBindPositioningDeviceInfos() {
                this.$Modal.confirm({
                    title: '确认绑定设备',
                    content: '<p>确认绑定设备</p>',
                    onOk: () => {
                        store.dispatch('InstallOrderServ_BindPositioningDeviceInfos', {
                            params: {
                                id: this.installOrder.id,
                                positioningDeviceInfoIds: this.selectPositioningDeviceInfos
                            }
                        }).then(() => {
                            this.$Message.success('修改成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            /**
             * 解绑订单设备
             */
            onunBindPositioningDeviceInfos(positioningDeviceInfoId) {
                this.$Modal.confirm({
                    title: '确认解绑设备',
                    content: '<p>确认解绑设备</p>',
                    onOk: () => {
                        store.dispatch('InstallOrderServ_UnBindPositioningDeviceInfos', {
                            params: {id: this.installOrder.id, positioningDeviceInfoIds: [positioningDeviceInfoId]}
                        }).then(() => {
                            this.$Message.success('解绑成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },

            /**
             * 增加设备配件
             */
            onaddPositioningDeviceFittingsInfos(){
            //    显示配件增加组件
                this.AddPositioningDeviceFittingsModalId = this.installOrder.id
                this.AddPositioningDeviceFittingsModal = true
            },
            onPositioningdevicefittings () {
                this.updateTable()
                this.installOrder.positioningDeviceInfos.forEach(positioningDeviceInfo =>{
                    if (positioningDeviceInfo.positioningDeviceModelId == this.installOrder.newPositioningDeviceFittingsModel.positioningDeviceModelId) {
                        store.dispatch('PositioningDeviceInfoServ_BindPositioningDeviceFittings', {
                            params: {
                                id: positioningDeviceInfo.id,
                                positioningdevicefittingsid: this.installOrder.newPositioningDeviceFittingsModel.positioningDeviceModelId
                            },
                            urlparams: null
                        }).then(() => {
                            this.updateTable()
                        }).catch(err => {
                            this.$Message.error(err)
                        })
                    }
                })
            },
            /**
             * 选择安装员
             */
            oninstallerId(){
                if (this.showinstallerId) {
                    this.showinstallerId = false
                } else {
                    this.showinstallerId = true
                }
            },
            onConfirminstallerId(value, index) {
                this.installOrder.installer = value
                store.dispatch('UserServ_GetPage', {
                    params: null,
                    urlparams: {keyword: this.installOrder.installer}
                }).then(() => {
                    if (store.getters.get_User_GetPageResult.content) {
                        this.installOrder.installerId = store.getters.get_User_GetPageResult.content[0].id
                    }
                }).catch(err => {
                })
                this.showinstallerId = false
            },
            onCancelinstallerId() {
                this.showinstallerId = false
            },

            /**
             * 更新页面
             */
            updateTable() {
                /**
                 * 查询该订单绑定的设备
                 */
                this.searchPositioningDeviceInfoList = []
                this.selectPositioningDeviceInfos = []
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {
                        id: this.installOrder.id
                    },
                    urlparams: null
                }).then(() => {
                    if (store.getters.get_InstallOrder_GetDetailResult) {
                        this.installOrder = store.getters.get_InstallOrder_GetDetailResult
                    }
                }).catch(err => {
                    console.log('查询该订单绑定的设备')
                    this.$Message.error(err)
                })

                /**
                 * 查询该订单绑定的设备配件
                 */
                let queryParams1 = []
                let sortParam1 = null
                queryParams1.push(genQueryParam('installOrderId', 'EQ', this.installOrder.id))
                store.dispatch('PositioningDeviceFittingsServ_GetAll', {
                    params: null,
                    urlparams: {
                        q: queryParams1,
                        keyword: null,
                        sort: sortParam1
                    }
                }).then(() => {
                    if (store.getters.get_PositioningDeviceFittings_GetAllResult) {
                        this.positioningDeviceFittingsInfos = store.getters.get_PositioningDeviceFittings_GetAllResult
                    }
                }).catch(err => {
                    console.log('查询该订单绑定的设备配件')
                    this.$Message.error(err)
                })

            },
            onSuccess(){
                this.mliftainsuranceChannelIdOptions = []
                this.tiinsuranceChannelIdOptions = []
                store.dispatch('InsuranceChannelServ_GetAll', {
                    params: null,
                    urlparams: null
                }).then(() => {
                    if (store.getters.get_InsuranceChannel_GetAllResult){
                        store.getters.get_InsuranceChannel_GetAllResult.forEach(item =>{
                            this.mliftainsuranceChannelIdOptions.push(item.name)
                            this.tiinsuranceChannelIdOptions.push(item.name)
                        })
                    }
                }).catch(err => {
                })
                this.businessUserIdOptions = []
                store.dispatch('UserServ_GetAllUsers', {
                    params: {},
                    urlparams: { roleIds: [7] }
                }).then(() => {
                    if (store.getters.get_User_GetAllUsersResult) {
                        store.getters.get_User_GetAllUsersResult.forEach(item => {
                            this.businessUserIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
                        })
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
                this.installerIdOptions = []
                store.dispatch('UserServ_GetAllUsers', {
                    params: {},
                    urlparams: { roleIds: [8,14] }
                }).then(() => {
                    if (store.getters.get_User_GetAllUsersResult) {
                        store.getters.get_User_GetAllUsersResult.forEach(item => {
                            this.installerIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
                        })
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
        },
        computed: {
            _value: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            console.log(this.$route.query.addinstall)
            this.onbackid = this.$route.query.addinstall
            this.mliftainsuranceChannelIdOptions = []
            this.tiinsuranceChannelIdOptions = []
            store.dispatch('InsuranceChannelServ_GetAll', {
                params: null,
                urlparams: null
            }).then(() => {
                if (store.getters.get_InsuranceChannel_GetAllResult){
                    store.getters.get_InsuranceChannel_GetAllResult.forEach(item =>{
                        this.mliftainsuranceChannelIdOptions.push(item.name)
                        this.tiinsuranceChannelIdOptions.push(item.name)
                    })
                }
            }).catch(err => {
            })
            this.businessUserIdOptions = []
            store.dispatch('UserServ_GetAllUsers', {
                params: {},
                urlparams: { roleIds: [7] }
            }).then(() => {
                if (store.getters.get_User_GetAllUsersResult) {
                    store.getters.get_User_GetAllUsersResult.forEach(item => {
                        this.businessUserIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
                    })
                }
            }).catch(err => {
                this.$Message.error(err)
            })
            this.installerIdOptions = []
            store.dispatch('UserServ_GetAllUsers', {
                params: {},
                urlparams: { roleIds: [8,14] }
            }).then(() => {
                if (store.getters.get_User_GetAllUsersResult) {
                    store.getters.get_User_GetAllUsersResult.forEach(item => {
                        this.installerIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
                    })
                }
            }).catch(err => {
                this.$Message.error(err)
            })
        }
    }
</script>
<style>
</style>
